import React, { useState, useEffect } from "react";

const CouponModal = ({ coupon, isOpen, onClose, onSave }) => {
  const [editedCoupon, setEditedCoupon] = useState(coupon);

  useEffect(() => {
    setEditedCoupon(coupon || {});
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [coupon, isOpen]);

  if (!isOpen || !coupon) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedCoupon({ ...editedCoupon, [name]: value });
  };

  const handleSave = () => {
    onSave(editedCoupon);
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-2xl max-h-screen overflow-y-auto">
        <h2 className="text-2xl font-semibold mb-4">Edit Coupon</h2>

        <div className="space-y-4">
          {Object.keys(editedCoupon).map((field) => (
            <div key={field} className="flex flex-col">
              <label className="font-semibold text-gray-700">{field}</label>
              <input
                type="text"
                name={field}
                value={editedCoupon[field] || ""}
                onChange={handleInputChange}
                className={`p-2 border border-gray-300 rounded ${
                  field === "offerId" || field === "store"
                    ? "bg-gray-100 text-gray-500 cursor-not-allowed"
                    : ""
                }`}
                disabled={field === "offerId" || field === "store"} // Disable input for offerId and store
              />
            </div>
          ))}
        </div>

        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="bg-gray-500 text-white py-2 px-4 rounded hover:bg-gray-600 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="bg-red-600 text-white py-2 px-4 rounded hover:bg-red-700 transition"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default CouponModal;
